<template>
  <span class="irr-calc-link" role="link" tabindex="0" @click="open" @keyup.enter="open">&gt;&gt; 进一步计算对应 IRR</span>
</template>

<script>
// 底层资产各业态计算器下方的入口：切到「估值分析 → IRR 计算」（IndividualShare/index.vue 监听 openIrrCalculator）。
export default {
  name: 'IrrCalcLink',
  methods: { open() { this.$eventBus.$emit('openIrrCalculator'); } },
};
</script>

<style scoped>
.irr-calc-link { display: inline-block; margin-top: 10px; margin-right: 16px; font-size: inherit; color: rgb(64, 158, 255); cursor: pointer; }
</style>
